import { Grid, Text } from "basis";
import { formatAmount } from "library/moneyUtils";
import { mapValueToLabel } from "library/utils";
import { Account } from "pages/HardshipApplication/reducer/types";
import { TextCell } from "pages/HardshipApplication/Review/TextCell";
import {
  accountTypeOptionsAu,
  accountTypeOptionsNz,
} from "pages/HardshipApplication/YourAccounts/yourAccountsForm";

type ReviewAccountProps = {
  account: Account;
  index: number;
  region: string;
};

export const ReviewAccount = ({
  account,
  index,
  region,
}: ReviewAccountProps) => {
  const accountTypeOptions =
    region === "AU" ? accountTypeOptionsAu : accountTypeOptionsNz;
  const { accountType, accountNumber, monthlyRepayments } = account;
  return (
    <Grid
      cols="8"
      colsGap-sm="4"
      rowsGap="8"
      testId={`account-${index + 1}-section`}
    >
      <Grid.Item colSpan="all" colSpan-sm="0-3" rowSpan-sm="0">
        <Text as="h4" textStyle="heading6" testId="account-heading">
          Account {index + 1} –{" "}
          {accountType && mapValueToLabel(accountType, accountTypeOptions)}
        </Text>
      </Grid.Item>
      <Grid.Item colSpan="all" colSpan-sm="0-8" rowSpan-sm="1">
        <TextCell header="Account number" testId="account-number">
          {accountNumber}
        </TextCell>
      </Grid.Item>
      <Grid.Item colSpan="all" colSpan-sm="0-8" rowSpan-sm="2">
        <TextCell
          header="How much are you able to afford for this account on a monthly basis?"
          testId="monthly-repayments"
        >
          {formatAmount(monthlyRepayments, { withCents: true })}
        </TextCell>
      </Grid.Item>
    </Grid>
  );
};
